import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { root } from 'client/core/sagas'
import rootReducer from 'client/core/reducers'

const initialState = {}
const sagaMiddleware = createSagaMiddleware()
const middleware = [sagaMiddleware]

export default function initStore(defaultStoreState) {
    let store
    const state = { ...initialState, ...defaultStoreState }

    if (__CLIENT) {
        store = createStore(
			rootReducer,
			state,
			compose(
				applyMiddleware(...middleware),
				window.devToolsExtension && window.__ENV !== 'production' ? window.devToolsExtension() : f => f
			)
		)

        if (module.hot) {
            module.hot.accept(() => {
                const nextRootReducer = require('../client/core/reducers').default  // eslint-disable-line global-require
                store.replaceReducer(nextRootReducer)
            })
        }
    } else {
        store = createStore(
			rootReducer,
			state,
			compose(
				applyMiddleware(...middleware)
			)
		)
    }

    store.runSaga = sagaMiddleware.run
    sagaMiddleware.run(root)
	
    return store
}


// WEBPACK FOOTER //
// ./src/common/store.js